// extracted by mini-css-extract-plugin
export default {"container":"event_container__1WOkT","inner":"event_inner__XA_zW","isContainer":"event_isContainer__3i0ho"};